// extracted by mini-css-extract-plugin
module.exports = {"adsGeneralSettingsWrapper":"ads-general-settings_adsGeneralSettingsWrapper__1ySIk","marginBottomXs":"ads-general-settings_marginBottomXs__5PrG1"};